export default "__VITE_ASSET__D5MwWkRz__"